import { SignedIn, SignedOut, SignInButton, useAuth } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import logo from '../logo.svg';

const callbackUrl = `${window.location.origin}/auth/callback?type=customer`;

/**
 * Customer-only landing after sign-out. Beautiful welcome + sign in.
 * Owners never see this; they go to / on sign out.
 */
export default function CustomerWelcome() {
  const { isLoaded } = useAuth();

  if (!isLoaded) {
    return (
      <div
        className="min-h-[100dvh] flex items-center justify-center text-slate-600"
        style={{ background: '#faf9f7' }}
      >
        <p className="text-sm">Loading…</p>
      </div>
    );
  }

  return (
    <>
      <SignedIn>
        <Navigate to="/profile" replace />
      </SignedIn>
      <SignedOut>
        <div
          className="relative min-h-[100dvh] flex flex-col items-center justify-center px-6 text-center overflow-hidden"
          style={{ background: '#faf9f7' }}
        >
          {/* Subtle warm accent glow */}
          <div className="absolute inset-0 pointer-events-none" aria-hidden>
            <div
              className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full opacity-15 blur-[100px]"
              style={{ background: 'radial-gradient(circle, #fb923c 0%, transparent 70%)' }}
            />
          </div>

          <div className="relative z-10 max-w-lg mx-auto">
            {/* Logo / brand - white circle for visibility, object-contain preserves aspect ratio */}
            <div className="flex justify-center mb-6">
              <div className="flex items-center justify-center w-20 h-20 rounded-full bg-white shadow-sm">
                <img src={logo} alt="Grab & Go" className="h-12 w-auto max-w-full object-contain" />
              </div>
            </div>

            {/* Headline */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight mb-6 text-slate-800">
              Save time.{' '}
              <span className="bg-gradient-to-r from-orange-500 to-orange-600 bg-clip-text text-transparent">
                Skip the line.
              </span>
            </h1>

            {/* Slogan */}
            <p className="text-lg sm:text-xl leading-relaxed mb-4 text-slate-600">
              Welcome to Grab & Go—where you order ahead, grab your food, and go.
            </p>
            <p className="text-base mb-12 max-w-md mx-auto text-slate-500">
              No more waiting. Order from your favorite truck, pay on your phone, and pick up when it’s ready.
            </p>

            {/* Sign in CTA */}
            <SignInButton mode="redirect" forceRedirectUrl={callbackUrl}>
              <button
                type="button"
                className="w-full max-w-xs mx-auto px-10 py-4 text-lg font-bold rounded-xl bg-orange-600 hover:bg-orange-500 text-white transition-all hover:shadow-lg active:scale-[0.98]"
              >
                Sign in to order
              </button>
            </SignInButton>
          </div>
        </div>
      </SignedOut>
    </>
  );
}
